module.exports = __webpack_public_path__ + "f9e52830aeba2f2fa7e1d52e33fe78ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thesafezone/certificado.jpg
// module id = 334
// module chunks = 1